import { useRef } from 'react';
import { DateInput } from './date-input';
import { Button } from './button';
import { getDateRange, cn } from '../../lib/utils';

const QUICK_BUTTONS = [
  { key: 'current-month', label: 'This Month' },
  { key: 'previous-month', label: 'Last Month' },
  { key: 'current-quarter', label: 'This Qtr' },
  { key: 'previous-quarter', label: 'Last Qtr' },
  { key: 'current-fy', label: 'This FY' },
  { key: 'previous-fy', label: 'Last FY' },
  { key: 'full-ledger', label: 'Full Ledger' },
];

export const DateRangeFilter = ({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  onApply,
  activeQuick,
  onQuickSelect,
  compact = false,
  'data-testid': testId = 'date-filter'
}) => {
  const startRef = useRef(null);
  const endRef = useRef(null);

  const isCustomMode = !activeQuick;

  const handleQuick = (key) => {
    const range = getDateRange(key);
    onStartDateChange(range.start_date);
    onEndDateChange(range.end_date);
    if (onQuickSelect) onQuickSelect(key);
    setTimeout(() => onApply(range.start_date, range.end_date), 0);
  };

  const handleStartKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      endRef.current?.focus();
    }
  };

  const handleEndKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      onApply(startDate, endDate);
      endRef.current?.blur();
    }
  };

  const dateHighlight = isCustomMode
    ? 'ring-2 ring-primary/60 ring-offset-1'
    : '';

  return (
    <div className="space-y-2 sm:space-y-0">
      {/* Quick buttons - scrollable on mobile, wrap on desktop */}
      <div className="flex sm:flex-wrap items-center gap-1.5 sm:gap-2 overflow-x-auto pb-1 sm:pb-0 -mx-1 px-1 scrollbar-hide">
        {QUICK_BUTTONS.map(btn => (
          <Button
            key={btn.key}
            type="button"
            variant={activeQuick === btn.key ? 'default' : 'outline'}
            size="sm"
            className="text-xs h-7 px-2 shrink-0"
            onClick={() => handleQuick(btn.key)}
            data-testid={`${testId}-${btn.key}`}
          >
            {btn.label}
          </Button>
        ))}
        {!compact && (
          <>
            <DateInput
              ref={startRef}
              value={startDate}
              onChange={(e) => { onStartDateChange(e.target.value); if (onQuickSelect) onQuickSelect(''); }}
              onKeyDown={handleStartKeyDown}
              className={cn("h-7 w-[110px] sm:w-[130px] text-xs transition-all shrink-0", dateHighlight)}
              data-testid={`${testId}-start`}
            />
            <span className="text-xs text-muted-foreground shrink-0">to</span>
            <DateInput
              ref={endRef}
              value={endDate}
              onChange={(e) => { onEndDateChange(e.target.value); if (onQuickSelect) onQuickSelect(''); }}
              onKeyDown={handleEndKeyDown}
              className={cn("h-7 w-[110px] sm:w-[130px] text-xs transition-all shrink-0", dateHighlight)}
              data-testid={`${testId}-end`}
            />
            <Button
              type="button"
              size="sm"
              className="h-7 text-xs shrink-0"
              onClick={() => onApply(startDate, endDate)}
              data-testid={`${testId}-apply`}
            >
              Go
            </Button>
          </>
        )}
      </div>
    </div>
  );
};
